import { comments } from '@/mocks/baoliao';

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            读者热议
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            看看大家都在讨论什么，加入吃瓜大军
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-xl">
                  {comment.avatar}
                </div>
                <div>
                  <div className="font-medium text-foreground-900 text-sm">{comment.username}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/50">
                <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes.toLocaleString()}</span>
                </button>
                <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
                <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer ml-auto">
                  <i className="ri-share-forward-line"></i>
                  <span>分享</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}